module.exports = __webpack_public_path__ + "img/logo_img.da7c0227.jpg";